import { useContext } from 'react';
import { Colors } from '@/common/colors/colors';
import SelectInput from '@/common/components/SelectInput';
import { AuthContext } from '@/common/contexts/authContext';
import {
	getQueuedProductIdsForSuperProduct,
	getTeamLeaderSuperProductOptions,
} from '@/common/functions/getTeamLeaderProductOptions';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';

export const useTeamSuperProductFilter = () => {
	const { authUser } = useContext(AuthContext);
	const {
		commonData: { users, queues, products },
	} = useCommonDataContext();

	const getProductIds = (superProductId) =>
		getQueuedProductIdsForSuperProduct({
			superProductId,
			users,
			queues,
			products,
			leaderId: authUser?.id,
		});

	return { getProductIds };
};

const TeamLeaderProductSelect = ({
	selected,
	setSelected,
	width = 120,
	margin = '10px',
	selectWidth = 220,
}) => {
	const { authUser } = useContext(AuthContext);
	const { translation } = useTranslationContext();
	const {
		commonData: { users, queues, products, superProducts },
	} = useCommonDataContext();

	const options = getTeamLeaderSuperProductOptions({
		users,
		queues,
		products,
		superProducts,
		leaderId: authUser?.id,
	});

	return (
		<SelectInput
			name={translation?.['Super product'] || 'Super product'}
			options={options}
			selected={selected}
			setSelected={setSelected}
			color={Colors.darkBlue}
			width={width}
			margin={margin}
			selectWidth={selectWidth}
			isClearable
			menuPortalTarget={document.body}
		/>
	);
};

export default TeamLeaderProductSelect;
